import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import QuoteFeatureService from '@/service/QuoteFeatureService';

export const useBookingQuoteStore = defineStore('bookingQuoteStore', {
  state: () => ({
    quote: {}
  }),
  actions: {
    async getQuoteDetail(id) {
      try {
        const quoteFeatureService = new QuoteFeatureService();
        const res = await quoteFeatureService.viewQuote(id);
        if (res) {
          this.quote = res.data;
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    }
  }
});
